import React, { useContext, useState, useCallback, useEffect ,useRef} from "react";
import Box from "@mui/material/Box";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { LeadsCustomFilters } from "../filters/LeadsCustomFilters";
import { CustomFilterableDataGrid } from "../../../../components/uiElements/customFilterabeDataGrid/CustomFilterableDataGrid";
import { LeadsCustomToolbar } from "../filters/LeadsCustomToolbar";
import { SidebarAllFilter } from "../filters/SidebarAllFilter";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { getColumns } from "./constants";
import {
  getLeadsIdsAfterFilter,
  setPeopleColumnsOrder,
  setPeopleColumnsVisibility,
  setPeopleFilter,
  setPeopleSort,
} from "../../../../redux/leads/getLeadList";
import { getLeadsListAPI } from "../../../../redux/leads/getLeadsListAPI";
import { AppContext } from "../../../../components/callPanel/callContext";
import { useDispatch, useSelector } from "react-redux";
import { handleMaximizeTab } from "../../../../redux/widgets";
import ResponseAlert from "../../../../components/responseAlert";
import { useLocation } from "react-router-dom";

const LeadsTable = ({
  classes,
  data,
  filters,
  sorting,
  stagesList,
  stagesListLoading,
  loading,
  columnsOrder,
  columnsVisibility,
  usersList,
  usersListLoading,
  usersObj,
  totalPeopleCount,
  tagsList,
  tempFilters,
  setTempFilters,
  tempSorting,
  setTempSorting,
  searchText,
}) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { dialNumber } = useContext(AppContext);
  const location = useLocation();
  const gridRef = useGridApiRef();

  const handleOpenWidget = (type, phone, email) => {
    if (!widgets[type]) {
      if (rightPositions.length) {
        if (
          rightPositions[rightPositions.length - 1].right + 1450 >
          window.innerWidth
        ) {
         handleAlert();
        } else {
          if (type === "sendTextOpen") {
            dispatch(
              handleMaximizeTab({
                type: type,
                action: true,
                tabDetail: {
                  toNumber: [phone],
                },
              })
            );
          } else {
            dispatch(
              handleMaximizeTab({
                type: type,
                action: true,
                tabDetail: {
                  toEmailList: [{ email: email, name: "" }],
                },
              })
            );
          }
        }
      } else {
        if (type === "sendTextOpen") {
          dispatch(
            handleMaximizeTab({
              type: type,
              action: true,
              tabDetail: {
                toNumber: [phone],
              },
            })
          );
        } else {
          dispatch(
            handleMaximizeTab({
              type: type,
              action: true,
              tabDetail: {
                toEmailList: [{ email: email, name: "" }],
              },
            })
          );
        }
      }
    } else {
      setErrorAlert({
        errorMsg: "You can't open this widget because already opened",
        errorType: "warning",
        isOpen: true,
      });
    }
  };

  const [columns, setColumns] = React.useState(
    getColumns(
      columnsOrder,
      stagesList,
      usersList,
      tagsList,
      dialNumber,
      handleOpenWidget
    )
  );

  const rightPositions = useSelector((state) => state.widgets.rightPositions);
  const widgets = useSelector((state) => state.widgets);
  const [errorAlert, setErrorAlert] = useState({
    errorMsg: "",
    errorType: "",
    isOpen: false,
  });

  // ✅ Track if this is the first render to avoid applying filters on mount
  const [isInitialized, setIsInitialized] = useState(false);
const debounceTimerRef = useRef(null);

  useEffect(() => {
    if (!stagesListLoading) {
      setColumns(
        getColumns(
          columnsOrder,
          stagesList,
          usersList,
          usersObj,
          dialNumber,
          handleOpenWidget
        )
      );
    }
  }, [columnsOrder, stagesListLoading]);

  useEffect(() => {
    gridRef.current.subscribeEvent("columnHeaderDragEnd", (params) => {
      let newCols = gridRef.current.getAllColumns();
      newCols.shift();
      newCols = newCols.map((c) => c.field);
      dispatch(setPeopleColumnsOrder(newCols));
    });
  }, []);

  const setFilters = (newFilters) => {
    dispatch(setPeopleFilter(newFilters));
  };

  const setSorting = (sortFilter) => {
    dispatch(setPeopleSort(sortFilter));
  };

  /**
   * ✅ MAIN FILTER APPLICATION LOGIC
   */
const applyFilters = useCallback(
  (newFilters) => {
    let fl = newFilters ? newFilters : tempFilters;


    // Operators that don't require a value to be valid
    const NO_VALUE_OPERATORS = [
      "isEmpty",
      "isNotEmpty",
      "isGood",
      "isBad",
    ];

    // Operators that REQUIRE a non-empty value
    const REQUIRES_VALUE_OPERATORS = [
      "contains",
      "startsWith",
      "notStartsWith",
      "<",
      ">",
      "<>",
      "isAnyOf",
      "not",
      "include",
      "exclude",
    ];

    // Validate filters based on operator type
    let appliedFilters = fl.reduce((prev, curr) => {
      const columnField = curr.columnField || curr.field;
      const operatorValue = curr.operatorValue || curr.operator;
      const value = curr.value;

      // Check if operator and columnField exist
      if (!columnField || !operatorValue) {
        return prev;
      }

      // Determine if this operator requires a value
      const needsValue = REQUIRES_VALUE_OPERATORS.includes(operatorValue);
      
      // Check if value is valid
      const hasValidValue =
        value !== undefined &&
        value !== null &&
        value !== "" &&
        (Array.isArray(value) ? value.length > 0 : true) &&
        (typeof value === "object" && !Array.isArray(value)
          ? Object.keys(value).length > 0
          : true);

      // Apply validation rules
      let isValid = false;

      if (NO_VALUE_OPERATORS.includes(operatorValue)) {
        // Operators that don't need values are always valid
        isValid = true;
      } else if (needsValue) {
        // Operators that need values - must have a valid value
        if (hasValidValue) {
          isValid = true;
        } else {
          isValid = false;
  
        }
      } else {
        // Other operators without specific rules
        isValid = true;
      }

      // Only add if valid
      if (isValid) {
        prev.push({
          columnField,
          operatorValue,
          value,
          id: curr.id,
        });
      }

      return prev;
    }, []);


    // Check if anything actually changed
    const filtersChanged =
      JSON.stringify(appliedFilters) !== JSON.stringify(filters);
    const sortingChanged =
      JSON.stringify(sorting) !== JSON.stringify(tempSorting);


    // ✅ FIXED: Only call API if we have valid applied filters OR sorting changed
    if ((appliedFilters.length > 0 && filtersChanged) || sortingChanged) {

      dispatch(
        getLeadsListAPI({
          filters: JSON.stringify(appliedFilters),
          ...tempSorting,
          pageSize: 25,
          pageNumber: 1,
          resetList: true,
          from_agentprofit: location?.state?.from_agentprofit,
          agentprofit_agent_id: location?.state?.agentprofit_agent_id,
          agentprofit_start_date: location?.state?.agentprofit_start_date,
          agentprofit_end_date: location?.state?.agentprofit_end_date,
          agentprofit_team_id: location?.state?.agentprofit_team_id,
          search: searchText || "",
        })
      );

      dispatch(
        getLeadsIdsAfterFilter({
          ...tempSorting,
          filters: JSON.stringify(appliedFilters),
          pageSize: 25,
          pageNumber: 1,
          resetList: true,
        })
      );

      setFilters(appliedFilters);
      setSorting(tempSorting);
    } else if (appliedFilters.length === 0 && filters.length > 0) {
      // ✅ If all filters became invalid, clear the filters

      dispatch(
        getLeadsListAPI({
          filters: JSON.stringify([]),
          ...tempSorting,
          pageSize: 25,
          pageNumber: 1,
          resetList: true,
          from_agentprofit: location?.state?.from_agentprofit,
          agentprofit_agent_id: location?.state?.agentprofit_agent_id,
          agentprofit_start_date: location?.state?.agentprofit_start_date,
          agentprofit_end_date: location?.state?.agentprofit_end_date,
          agentprofit_team_id: location?.state?.agentprofit_team_id,
          search: searchText || "",
        })
      );

      dispatch(
        getLeadsIdsAfterFilter({
          ...tempSorting,
          filters: JSON.stringify([]),
          pageSize: 25,
          pageNumber: 1,
          resetList: true,
        })
      );

      setFilters([]);
      setSorting(tempSorting);
    } else {
      console.log("✅ No valid changes detected, skipping API call");
    }
  },
  [filters, sorting, tempSorting, tempFilters, dispatch, location, searchText]
);
  /**
   * ✅ AUTO-APPLY FILTERS WITH DEBOUNCING (prevents duplicate API calls)
   */
  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }


    // ✅ Clear previous timer to prevent multiple API calls
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // ✅ Set new timer - only call API after 500ms of no changes
    debounceTimerRef.current = setTimeout(() => {
      applyFilters(tempFilters);
    }, 300); // 300ms debounce delay

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [tempFilters, isInitialized, applyFilters]);


const handleFilterChange = useCallback(
  (model) => {
    const newItems = model.items;
    const oldItems = tempFilters;

    // ✅ FIXED: Check for ANY change - operator, value, count, order
    let hasChanged = false;

    // Check if count changed
    if (newItems.length !== oldItems.length) {
      hasChanged = true;
    }

    // Check if any item changed
    if (!hasChanged) {
      for (let i = 0; i < newItems.length; i++) {
        const newItem = newItems[i];
        const oldItem = oldItems[i];

        if (!oldItem) {
          hasChanged = true;
          break;
        }

        // Check each property individually to catch operator changes
        if (
          newItem.id !== oldItem.id ||
          newItem.columnField !== oldItem.columnField ||
          newItem.field !== oldItem.field ||
          newItem.operator !== oldItem.operator ||
          newItem.operatorValue !== oldItem.operatorValue ||
          JSON.stringify(newItem.value) !== JSON.stringify(oldItem.value)
        ) {
          hasChanged = true;
          break;
        }
      }
    }


    if (hasChanged) {
      setTempFilters(newItems);
    } else {
      console.log("ℹ️ No changes detected");
    }
  },
  [tempFilters]
);

  const onRowClick = async ({ id }) => {
    navigate(`/leads/people/details/${id}`);
  };

  const handleAlert = () => {
    setErrorAlert({
      errorMsg:
        "You can't open this widget because browser width is not enough for this!",
      errorType: "warning",
      isOpen: true,
    });
  };

  return (
  <>
      <Box
        sx={{
          margin: "10px 5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1" component="p">
          Showing {totalPeopleCount} People
        </Typography>
      </Box>
      <Grid container spacing={1}>
        <Grid item lg={filters?.length === 0 ? 12 : 9} md={12}>
          <Box className={classes.tableRoot}>
            <CustomFilterableDataGrid
              columns={columns}
              rows={data}
              columnVisibilityModel={columnsVisibility}
              apiRef={gridRef}
              sortModel={
                sorting.sortBy
                  ? [{ field: sorting.sortBy, sort: sorting.sortOrder }]
                  : []
              }
              filters={tempFilters}
              rowHeight={56}
              checkboxSelection
              loading={loading}
              filterMode="server"
              sortingMode="server"
              filterPanel={LeadsCustomFilters}
              toolbarPanel={LeadsCustomToolbar}
              onRowsScrollEnd={(e) => {
                if (totalPeopleCount > e.visibleRowsCount && !loading) {
                  dispatch(
                    getLeadsListAPI({
                      ...sorting,
                      pageNumber: Number(e.visibleRowsCount / 25) + 1,
                      pageSize: 25,
                      filters: JSON.stringify(filters),
                      from_agentprofit: location?.state?.from_agentprofit,
                      agentprofit_agent_id:
                        location?.state?.agentprofit_agent_id,
                      agentprofit_start_date:
                        location?.state?.agentprofit_start_date,
                      agentprofit_end_date:
                        location?.state?.agentprofit_end_date,
                      agentprofit_team_id: location?.state?.agentprofit_team_id,
                      search: searchText || "",
                    })
                  );
                }
              }}
              onSortModelChange={(e) => {
                setTempSorting(
                  e[0] ? { sortBy: e[0].field, sortOrder: e[0].sort } : {}
                );
              }}
              onRowClick={(param) => onRowClick(param)}
              onPreferencePanelClose={(opened) => {
                if (opened.openedPanelValue === "filters") {
                  console.log("✅ Filter panel closed");
                }
              }}
              onColumnVisibilityModelChange={(visibility) => {
                dispatch(setPeopleColumnsVisibility(visibility));
              }}
              onFilterModelChange={handleFilterChange}
            />
          </Box>
        </Grid>
        {filters?.length > 0 ? (
          <Grid item lg={3} md={12}>
            <SidebarAllFilter
              filters={tempFilters}
              columns={columns}
              apiRef={gridRef}
              apiCallApplyFilter={(filter) => {
                setTempFilters(filter);
              }}
            />
          </Grid>
        ) : null}
        <ResponseAlert
          open={errorAlert.isOpen}
          setOpen={() =>
            setErrorAlert({ errorMsg: "", errorType: "", isOpen: false })
          }
          alertType={errorAlert.errorType}
          alertMessage={errorAlert.errorMsg}
        />
      </Grid>
    </>
  );
};

export default withStyles(styleSheet, { name: "LeadsTableStyle" })(LeadsTable);